import { getPhotographer, getAllMediasForPhotographer } from "../../../app/lib/prisma-db";
import PhotographerPage from "./PhotographerPage";

export default async function Page({params}){
    const { slug } = await params;
    const id = parseInt(slug.split("-")[0]);
    const photographer = await getPhotographer(id);
    const medias = await getAllMediasForPhotographer(id);

    return(
        <PhotographerPage
            photographer={photographer}
            medias={medias}
        />
    )
}

